module.exports = __webpack_public_path__ + "img/icone-orange.55e566f9.svg";